import axios from "axios";

const instance = axios.create({
    baseURL: "https://linguaac-51eee2ca11b8.herokuapp.com/api/v1",
});

instance.interceptors.request.use(config =>{
    const token = localStorage.getItem("token");
    if (token){
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default instance;